// extracted by mini-css-extract-plugin
export default {"label":"AxisLabel_label__tq5dv","x":"AxisLabel_x__NxMrG","y":"AxisLabel_y__k8OpM"};